"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _selectn = require("selectn");

var _selectn2 = _interopRequireDefault(_selectn);

var _lodash = require("lodash");

var _reactRouter = require("react-router");

var _reactRedux = require("react-redux");

var _reactBootstrap = require("react-bootstrap");

var _API = require("../../API");

var _reactIntl = require("react-intl");

var _connectRouter = require("../../../decorators/connectRouter");

var _connectRouter2 = _interopRequireDefault(_connectRouter);

var _reactCssModules = require("react-css-modules");

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _actions = require("../../reducers/reportDetail/actions");

var reportDetailActions = _interopRequireWildcard(_actions);

var _ReportDetailEditTitleModal = require("./ReportDetailEditTitleModal");

var _ReportDetailEditTitleModal2 = _interopRequireDefault(_ReportDetailEditTitleModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var styles = require("./ReportDetailSidebar.less");

var ReportDetailSidebar = function (_React$Component) {
    _inherits(ReportDetailSidebar, _React$Component);

    function ReportDetailSidebar(props) {
        _classCallCheck(this, ReportDetailSidebar);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ReportDetailSidebar).call(this, props));

        _this.onShowEditTitleModal = function (e) {
            e.preventDefault();
            _this.showModal("editTitle", true);
        };
        _this.showModal = function (modal, show) {
            if (show) {
                _this.setState({ showModal: modal });
            } else {
                _this.setState({ showModal: null });
            }
        };
        _this.saveReport = function () {
            _this.props.dispatch(reportDetailActions.saveSelectedReport());
            // this.props.onSaveButtonPressed();
        };
        _this.moveReportToState = function (state) {
            var continueWithoutUpgrade = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

            var selectedReport = _this.props.reportDetail.selectedReport;
            // Inform user upgrade is available, when: Initial click on approve AND new version exists
            if (continueWithoutUpgrade === false && selectedReport.currentVersion < selectedReport.latestVersion) {
                var newState = _this.state; // ???
                newState.versionIsOldModal = {
                    reportDetail: _this.props.reportDetail
                };
                _this.setState(newState);
            } else {
                _this.props.dispatch(reportDetailActions.saveSelectedReport(state));
                _this.onHide();
            }
            // this.props.onSaveButtonPressed();
        };
        _this.reopenReport = function (value) {
            if (value) {
                _API.client.request(_API.API.giveReasonForSendingBackReport(_this.props.reportDetail.selectedReport.uid, value));
            }
            var newState = _this.state;
            newState.showReopenModal = false;
            _this.setState(newState);
            _this.moveReportToState("open");
        };
        _this.onHide = function () {
            var newState = _this.state;
            newState.showReopenModal = false;
            newState.versionIsOldModal = false;
            _this.setState(newState);
        };
        _this.state = {
            showModal: null,
            showReopenModal: false,
            versionIsOldModal: false
        };
        return _this;
    }

    _createClass(ReportDetailSidebar, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var listElements = null;
            var _props$reportDetail = this.props.reportDetail;
            var selectedReport = _props$reportDetail.selectedReport;
            var selectedReportDefinition = _props$reportDetail.selectedReportDefinition;
            var reportData = _props$reportDetail.reportData;
            var reportStepData = _props$reportDetail.reportStepData;
            var isSynchronized = _props$reportDetail.isSynchronized;

            var permission = this.props.auth.highestPermission;
            var reopenModal = React.createElement(_reactBootstrap.Modal, { show: this.state.showReopenModal, onHide: function onHide() {
                    return _this2.onHide();
                }, enforceFocus: false }, React.createElement(_reactBootstrap.Modal.Header, { closeButton: true }, React.createElement(_reactBootstrap.Modal.Title, null, React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.sidebar.reopen.button.title" }))), React.createElement(_reactBootstrap.Modal.Body, null, React.createElement(_reactBootstrap.Row, null, React.createElement(_reactBootstrap.Col, { xs: 12 }, React.createElement("form", { onSubmit: function onSubmit(__value) {
                    __value.preventDefault();var _value = __value;var value = _value.target.elements[0].value;_this2.reopenReport(value);var newState = _this2.state;newState.showReopenModal = false;_this2.setState(newState);
                } }, React.createElement(_reactBootstrap.FormGroup, null, React.createElement(_reactBootstrap.ControlLabel, null, "Grund"), React.createElement(_reactBootstrap.FormControl, { componentClass: "textarea" })), React.createElement(_reactBootstrap.Button, { type: "submit" }, "OK"))))));
            var versionIsOldModal = React.createElement(_reactBootstrap.Modal, { show: this.state.versionIsOldModal, onHide: function onHide() {
                    return _this2.onHide();
                }, enforceFocus: false }, React.createElement(_reactBootstrap.Modal.Header, { closeButton: true }, React.createElement(_reactBootstrap.Modal.Title, null, "Für diesen Befund gibt es eine neuere Version")), React.createElement(_reactBootstrap.Modal.Body, null, React.createElement(_reactBootstrap.Row, null, React.createElement(_reactBootstrap.Col, { xs: 3 }, "Befundvorlage: "), React.createElement(_reactBootstrap.Col, { xs: 9 }, this.state.versionIsOldModal && this.state.versionIsOldModal.reportDetail.selectedReportDefinition.title)), React.createElement(_reactBootstrap.Row, null, React.createElement(_reactBootstrap.Col, { xs: 3 }, "Befund: "), React.createElement(_reactBootstrap.Col, { xs: 9 }, this.state.versionIsOldModal && this.state.versionIsOldModal.reportDetail.selectedReport.title)), React.createElement(_reactBootstrap.Row, null, React.createElement(_reactBootstrap.Col, { xs: 3 }, "Version: "), React.createElement(_reactBootstrap.Col, { xs: 9 }, this.state.versionIsOldModal && this.state.versionIsOldModal.reportDetail.selectedReport.currentVersion)), React.createElement(_reactBootstrap.Row, null, React.createElement(_reactBootstrap.Col, { xs: 3 }, "Neuste Version: "), React.createElement(_reactBootstrap.Col, { xs: 9 }, this.state.versionIsOldModal && this.state.versionIsOldModal.reportDetail.selectedReport.latestVersion))), React.createElement(_reactBootstrap.Modal.Footer, null, React.createElement("p", { style: { "text-align": "left" } }, "Möchten Sie dennoch fortfahren und diesen Befund freigeben, ohne zuvor auf die neuste Version upzugraden?"), React.createElement(_reactBootstrap.Button, { bsStyle: "default", onClick: function onClick() {
                    var newState = _this2.state;newState.versionIsOldModal = false;_this2.setState(newState);
                } }, "Abrechen"), React.createElement(_reactBootstrap.Button, { bsStyle: "primary", onClick: function onClick() {
                    return _this2.moveReportToState("approved", true);
                } }, "Fortfahren")));
            if (selectedReport && selectedReportDefinition && (0, _selectn2.default)("selectedReport.userUid", this.props.reportDetail) && (0, _selectn2.default)("appUserProfile.uid", this.props.user)) {
                (function () {
                    var isManager = permission !== "user";
                    var userRole = permission === "manager" ? "manager" : "user";
                    var isOwnReport = _this2.props.user.appUserProfile.uid === _this2.props.reportDetail.selectedReport.userUid;
                    var baselink = "/reports/detail/" + _this2.props.reportDetail.selectedReport.uid;
                    listElements = React.createElement("ul", { styleName: "list" }, React.createElement("li", { style: { marginLeft: 10, marginRight: 10 } }, function () {
                        if (_this2.props.reportDetail.selectedReport.userUid === _this2.props.user.appUserProfile.uid && _this2.props.reportDetail.selectedReport.state === "open") {
                            return React.createElement("a", { href: "#", onClick: _this2.onShowEditTitleModal }, React.createElement("h5", null, selectedReport.title, " ", React.createElement("span", { className: "pull-right" }, React.createElement("i", { className: "fa fa-pencil" }))));
                        } else {
                            return React.createElement("h5", null, selectedReport.title);
                        }
                    }()), React.createElement("li", { style: { marginLeft: 10, marginRight: 10 } }, React.createElement("p", null, React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.report.state" }), " ", function () {
                        switch (_this2.props.reportDetail.selectedReport.state) {
                            case "open":
                                return React.createElement(_reactIntl.FormattedMessage, { id: "reportList.open.title." + userRole });
                            case "closed":
                                return React.createElement(_reactIntl.FormattedMessage, { id: "reportList.closed.title." + userRole });
                            case "approved":
                                return React.createElement(_reactIntl.FormattedMessage, { id: "reportList.approved.title." + userRole });
                        }
                    }())), function () {
                        return (0, _lodash.chain)(reportData).map(function (item) {
                            return React.createElement("li", { key: item.dataDefinition.uid, styleName: "mainitem" }, React.createElement(_reactRouter.Link, { styleName: "link", to: baselink + "/" + item.dataKey + "/" + item.dataDefinition.uid, activeClassName: styles.linkActive }, item.dataDefinition.namePlural, React.createElement("span", { className: "pull-right" }, "(", item.dataEntries.length, ")")));
                        }).value();
                    }(), React.createElement("li", { styleName: "branditem" }, React.createElement(_reactIntl.FormattedMessage, { id: "report.detail.sidebar.steps.title" })), function () {
                        return (0, _lodash.chain)(reportStepData).filter(function (stepData) {
                            if (isManager) {
                                if (!isOwnReport) {
                                    return stepData.stepDefinition.type !== "closingUser";
                                } else {
                                    return true;
                                }
                            } else {
                                return stepData.stepDefinition.type !== "closingManager";
                            }
                        }).map(function (item) {
                            var checkMark = item.isValid ? React.createElement("i", { className: "fa fa-check" }) : null;
                            var title = React.createElement("span", null, item.stepDefinition.title);
                            if (item.stepDefinition.type === "closingUser") {
                                title = React.createElement("span", null, React.createElement(_reactIntl.FormattedMessage, { id: "reportStep.type.closingUser" }));
                            } else if (item.stepDefinition.type === "closingManager") {
                                title = React.createElement("span", null, React.createElement(_reactIntl.FormattedMessage, { id: "reportStep.type.closingManager" }));
                            }
                            return React.createElement("li", { key: item.stepDefinition.uid + "step", styleName: "mainitem" }, React.createElement(_reactRouter.Link, { styleName: "link", to: baselink + "/steps/" + item.stepDefinition.uid, activeClassName: styles.linkActive }, checkMark, " ", title));
                        }).value();
                    }(), React.createElement("li", { key: "reopenReasonsList", styleName: "mainitem" }, React.createElement(_reactRouter.Link, { styleName: "link", to: baselink + "/" + "reopenReasonsList/test", activeClassName: styles.linkActive }, "Gründe fürs Zurückschicken")));
                })();
            }
            var stepButton = null;
            var reopenButton = null;
            var saveButton = null;
            var showErrorsButton = null;
            var countButtons = 0;
            if (this.props.auth.highestPermission && this.props.user.appUserProfile && this.props.reportDetail.selectedReport) {
                var _permission = this.props.auth.highestPermission;
                var _isManager = _permission !== "user";
                var _isOwnReport = this.props.user.appUserProfile.uid === this.props.reportDetail.selectedReport.userUid;
                var isSharedWith = this.props.reportDetail.selectedReport.sharedWith.indexOf(this.props.user.appUserProfile.UserId) !== -1;
                var checkEnabled = function checkEnabled(filter) {
                    return (0, _lodash.chain)(_this2.props.reportDetail.reportStepData).filter(function (reportData) {
                        return !(0, _lodash.includes)(filter, reportData.stepDefinition.type);
                    }).map(function (reportData) {
                        return reportData.isValid;
                    }).thru(function (validationResult) {
                        return !(0, _lodash.includes)(validationResult, false);
                    }).value();
                };
                var isLoading = (0, _selectn2.default)("pending", this.props.reportDetail.saveReportDataPromiseState);
                switch ((0, _selectn2.default)("selectedReport.state", this.props.reportDetail)) {
                    case "open":
                        if (_isOwnReport) {
                            var isEnabled = checkEnabled(["closingManager"]);
                            stepButton = React.createElement(_reactBootstrap.Button, { bsSize: "small", disabled: !isEnabled || isLoading || !isSynchronized, bsStyle: "default", onClick: function onClick() {
                                    return _this2.moveReportToState("closed");
                                } }, React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.sidebar.close.button.title" }));
                            countButtons = 2;
                        } else {
                            countButtons = 1;
                        }
                        saveButton = React.createElement(_reactBootstrap.Button, { bsSize: "large", disabled: !_isOwnReport && !isSharedWith || isLoading, bsStyle: "primary", onClick: this.saveReport }, React.createElement(_reactIntl.FormattedMessage, { id: "reportList.save.title" }), isSynchronized ? "" : "*", " ", React.createElement("i", { className: "fa fa-upload" }));
                        showErrorsButton = React.createElement(_reactBootstrap.Button, { bsSize: "large", disabled: isLoading, bsStyle: "danger", onClick: this.props.onShowErrorsButtonPressed }, this.props.showErrors ? "Fehlende Eingaben ausblenden" : "Fehlende Eingaben anzeigen");
                        break;
                    case "closed":
                        if (_isManager) {
                            var _isEnabled = checkEnabled(["closingUser", "normal"]);
                            stepButton = React.createElement(_reactBootstrap.Button, { bsSize: "small", bsStyle: "default", disabled: !_isEnabled || isLoading || !isSynchronized, onClick: function onClick() {
                                    return _this2.moveReportToState("approved", false);
                                } }, React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.sidebar.approve.button.title" }));
                            reopenButton = React.createElement(_reactBootstrap.Button, { bsSize: "small", bsStyle: "default", disabled: isLoading || !isSynchronized, onClick: function onClick() {
                                    var newState = _this2.state;newState.showReopenModal = true;_this2.setState(newState);
                                } }, React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.sidebar.reopen.button.title" }));
                            countButtons = 3;
                        } else {
                            countButtons = 1;
                        }
                        saveButton = React.createElement(_reactBootstrap.Button, { bsSize: "large", disabled: !_isManager || isLoading, bsStyle: "primary", onClick: this.saveReport }, React.createElement(_reactIntl.FormattedMessage, { id: "reportList.save.title" }), " ", isSynchronized ? "" : "*", React.createElement("i", { className: "fa fa-upload" }));
                        showErrorsButton = React.createElement(_reactBootstrap.Button, { bsSize: "large", disabled: isLoading, bsStyle: "danger", onClick: this.props.onShowErrorsButtonPressed }, "Fehlende Eingaben anzeigen");
                        break;
                    case "approved":
                        break;
                }
            }
            return React.createElement("div", null, React.createElement("div", { styleName: "list-container-" + countButtons }, listElements, React.createElement("div", { style: { clear: "all" } })), React.createElement("div", { styleName: "button-container-" + countButtons }, React.createElement(_reactBootstrap.ButtonGroup, { vertical: true, style: { width: "calc(100% - 20px)", marginLeft: 10, marginRight: 10, marginTop: 6 } }, saveButton, showErrorsButton, stepButton, reopenButton)), React.createElement(_ReportDetailEditTitleModal2.default, { selectedReport: this.props.reportDetail.selectedReport, onClose: function onClose() {
                    return _this2.showModal("editTitle", false);
                }, onSuccess: function onSuccess() {
                    return _this2.showModal("editTitle", false);
                }, showModal: this.state.showModal === "editTitle" }), reopenModal, versionIsOldModal);
        }
    }]);

    return ReportDetailSidebar;
}(React.Component);
ReportDetailSidebar = __decorate([(0, _reactRedux.connect)(function (state) {
    return {
        reportDetail: state.reportDetail,
        routing: state.routing,
        auth: state.auth,
        user: state.user
    };
}), _connectRouter2.default, _reactIntl.injectIntl, (0, _reactCssModules2.default)(styles)], ReportDetailSidebar);
exports.default = ReportDetailSidebar;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/containers/reportDetail/ReportDetailSidebar.tsx
 ** module id = 1279
 ** module chunks = 0
 **/